import React, { useState } from 'react';
import './Footer.css';
import logo1 from '../../assets/PSJ(logo).png';
import { Link } from 'react-router-dom';
import f1 from '../../assets/f1.png';
import f2 from '../../assets/f2.png';
import f3 from '../../assets/f3.jpg';
import f4 from '../../assets/f4.png';
import f5 from '../../assets/f5.jpeg';
import f6 from '../../assets/f6.png';
import f7 from '../../assets/f7.jpeg';

const Footer = () => {
  const [showServices, setShowServices] = useState(false);

  return (
    <>
      <footer className="footer">
        <div className="footer-red-strip">
          <div className="footer-red-strip-content">
            <h2>Want To Work With Us?</h2>
            <Link className="footer-claim-button" onClick={() => window.open("https://forms.gle/JeYr8cGJet8gNcMG6", "_blank")}>Book An Appointment ↗</Link>
          </div>
        </div>

        <div className="footer-main">
          <div className="footer-column logo-column">
            <img src={logo1} alt="INSURIGO" />
            <p>At PSJ Capital Ventures, We provide perspective, structure, and strategic clarity. Our approach is deeply rooted in research, disciplined in execution, and built around each client’s vision and financial reality. </p>
          </div>

          <div className="footer-column">
            <h3>Quick links</h3>
            <ul>
              <Link to='/'><li>Home</li></Link>
              <Link to='/about'><li>About Us</li></Link>
              <li onClick={() => setShowServices(!showServices)} className="service-toggle">
                Our Services <i class="fa-solid fa-caret-down"></i>
              </li>

              {showServices && (
                <div className="service-list-inside">
                  <ul>
                    <Link to='/mutual-funds'><li>mutual-funds →</li></Link>
                    <Link to='/portfolio-management-services'><li>Portfolio Management Services →</li></Link>
                    <Link to='/alternative-investment-funds'><li>Alternative Investment Funds →</li></Link>
                    <Link to='/macro-treasury-research'><li>Macro/Treasury Research →</li></Link>
                    <Link to='/nri-corner'><li>NRI Corner →</li></Link>
                    <Link to='/family-offices'><li>Family Offices →</li></Link>
                    <Link to='/insurance'><li>Insurance →</li></Link>
                    <Link to='/loan-syndication'><li>Loan Syndication→</li></Link>
                    <Link to='/fundraising-assistance'><li>Fundraising Assistance →</li></Link>
                    <Link to='/sme-ipo-advisory'><li>SME IPO Advisory →</li></Link>
                    <Link to='/stock-broking'><li>Stock Broking →</li></Link>
                  </ul>
                </div>
              )}

              <Link to='https://www.youtube.com/@PSJCAPITALVENTURES' target='_blank'><li>Fund-o-pedia</li></Link>
              <Link to='/blog'><li>Blogs</li></Link>
              <Link to='/contact'><li>Contact Us</li></Link>
              <Link to='/calculators'><li>Calculator</li></Link>
            </ul>
          </div>

          <div className="footer-column">
            <h3>Social Media</h3>
            <p>Follow us on social media for updates, insights, and expert financial guidance.</p>


            <div className="footer-socials">
             <a
  href="https://www.instagram.com/psjcapitalofficial/"
  target="_blank"
  rel="noopener noreferrer"
  aria-label="Instagram"
>
  <i className="fab fa-instagram"></i>
</a>

              <Link to='https://www.linkedin.com/company/psj-capital-ventures/' target='_blank'><i class="fa-brands fa-linkedin"></i></Link>
              <Link to='https://www.youtube.com/@PSJCAPITALVENTURES' target='_blank'><i className="fa-brands fa-youtube"></i></Link>
              <Link to='https://x.com/PSJCAPITAL?t=rGFu7sIyfYbwws4C4xCDLQ&s=09' target='_blank'><i class="fa-brands fa-x-twitter"></i></Link>
              <Link to='https://www.facebook.com/profile.php?id=61575921059220&rdid=wd75JgB9Z2koC7S2&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1YfhDe2xk5%2F#' target='_blank'><i class="fa-brands fa-square-facebook"></i></Link>
              <Link to='https://wa.me/918108430942' target="_blank" ><i class="fa-brands fa-square-whatsapp"></i></Link>
            </div>
            <div className="footer-socials1">
              <img src={f1} alt=''></img>
              <img src={f2} alt=''></img>
              <img src={f3} alt=''></img>
              <img src={f4} alt=''></img>
              <img src={f5} alt=''></img>
              <img src={f6} alt=''></img>
              <img src={f7} alt=''></img>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-contact">
            <div className="footer-box"><strong>Call Us</strong><br /> +91 7503202375 </div>
            <div className="footer-box"><strong>Email Us</strong><br /> priyanshu@psjcapitalventures </div>
            <div className="footer-box">
              <strong>Connect On WhatsApp</strong><br />
              {/* <Link to='https://wa.me/918108430942' target="_blank" style={{ color: 'black' }}><i class="fa-brands fa-square-whatsapp"></i></Link> <Link to='https://wa.me/918108430942' target="_blank" style={{ textDecoration: 'none', color: 'black' }}>Contact Now</Link></div> */}
              <Link to='https://wa.me/918108430942' target="_blank" style={{ color: 'black' }}><i class="fa-brands fa-square-whatsapp"></i></Link> <Link to='https://wa.me/917503202375' target="_blank" style={{ textDecoration: 'none', color: 'black' }}>Contact Now</Link></div>
          </div>
          <div className="footer-links">
            <span>
              © 2025 PSJ Capital Ventures. Developed by <Link to='https://www.digithack.in/' target='_blank' className='mx-0'>DIGIT HACK SOFTWARE SOLUTIONS</Link>
            </span>
            <div className="footer-policy-links">
              <Link to="/privacy-policy" className="policy-link">Privacy Policy</Link>
              <span> | </span>
              <Link to="/disclaimer" className="policy-link">Disclaimer</Link>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
